var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-position",on:{"click":_vm.closeBackdrop}},[_c('div',{staticClass:"dialog-container",style:(`max-width: ${_vm.dialogWidth}`)},[_c('div',{staticClass:"close drip-text-button",on:{"click":_vm.closeDialog}},[_c('b-icon-x',{staticClass:"color-wealthy-green-500",attrs:{"scale":"1.6"}})],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }